export const MAIN_MENU_HIDDEN_BTN_BACK = ['broadcastEmail', 'groupEmail', 'draftBroadcastEmail']

export const noNavbar = ['groupEmail', 'sendEmail', 'broadcastEmail', 'detailGroupEmail', 'detailBroadcastEmail']